import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import { firebaseConfig, firebaseVapidKey } from "@/config/firebase";

export const isPushEnabled = (): boolean =>
  process.env.VUE_APP_DISABLE_PUSH !== "true";

export const requestPushPermission = async (): Promise<string | null> => {
  if (!isPushEnabled() || !("serviceWorker" in navigator)) return null;

  try {
    await navigator.serviceWorker.register("/firebase-messaging-sw.js");

    const permission = await Notification.requestPermission();
    if (permission !== "granted") return null;

    const firebaseApp = initializeApp(firebaseConfig);
    const messaging = getMessaging(firebaseApp);

    return await getToken(messaging, { vapidKey: firebaseVapidKey });
  } catch (err) {
    console.error("Push permission/token error:", err);
    return null;
  }
};
